/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Transfer between main account and its subaccount
 */
export interface SubAccountTransferRequest {
  /**
   * Source account ID
   */
  fromAccountId: number;
  /**
   * Destination account ID
   */
  toAccountId: number;
  /**
   * Asset Code
   */
  assetCode: string;
  /**
   * Transfer quantity
   */
  quantity: number;
  /**
   * Note
   */
  note?: string;
}
